// Get updated profiles
export const getUpdatedUser = (state) => state.dashboard.data?.newUpdatedProfiles || [];

// Get new jobs
export const getNewJobs = (state) => state.dashboard.data?.newJobs || [];

// Get new users
export const getNewUsers = (state) => state.dashboard.data?.newUsers || [];

// Get applied jobs / users
export const getAppliedJobs = (state) => state.dashboard.data?.newAppliedUsers || [];
